import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import StatsSection from './components/StatsSection';
import ReviewSection from './components/ReviewSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'Organization',
                name: 'KY App',
                url: 'https://www.ky.app',
                description: 'KY应用官方指定地址，提供最新版本极速下载、安全安装与账号注册服务',
                contactPoint: {
                  '@type': 'ContactPoint',
                  email: 'support@ky.app',
                  contactType: 'customer service',
                  availableLanguage: ['Chinese'],
                },
              },
              {
                '@type': 'WebSite',
                name: 'KY App 官方网站',
                url: 'https://www.ky.app',
                potentialAction: {
                  '@type': 'SearchAction',
                  target: 'https://www.ky.app/search?q={search_term_string}',
                  'query-input': 'required name=search_term_string',
                },
              },
              {
                '@type': 'WebPage',
                name: 'www.ky.app 官方入口·极速下载安装',
                description: 'www.ky.app 是您访问KY应用的官方指定地址，提供最新版本极速下载、安全安装与账号注册服务。',
                url: 'https://www.ky.app/',
                isPartOf: { '@id': 'https://www.ky.app/#website' },
                about: { '@id': 'https://www.ky.app/#organization' },
              },
              {
                '@type': 'FAQPage',
                mainEntity: [
                  {
                    '@type': 'Question',
                    name: 'www.ky.app 是官方下载地址吗？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: '是的，www.ky.app 是 KY 应用的唯一官方指定下载地址。我们建议所有用户仅通过此地址下载，以确保应用的安全性和功能完整性。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: 'KY App 支持哪些平台？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'KY App 目前支持 iOS（14.0及以上版本）和 Android（8.0及以上版本）两大主流移动平台。',
                    },
                  },
                  {
                    '@type': 'Question',
                    name: '下载和安装 KY App 需要付费吗？',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: 'KY App 的下载和安装完全免费。部分高级功能可能需要付费订阅，但基础功能对所有用户永久免费开放。',
                    },
                  },
                ],
              },
            ],
          }),
        }}
      />

      <Navbar />
      <main>
        <article>
          <HeroSection />
          <FeatureSection />
          <StatsSection />
          <ReviewSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}